import { gql } from '@apollo/client';

export const UPLOAD_DOCUMENTS = gql`
  mutation UploadDocuments($data: [CreateDocumentInput!]!) {
    uploadDocuments(data: $data) {
      id
      type
      contentType
      key
      bucket
      name
      status
      createdAt
      foreignKeys
      presignedUrl
      documentContentId
    }
  }
`;

export const ATTACH_DOCUMENTS = gql`
  mutation AttachDocuments($data: AttachDocumentInput!) {
    attachDocuments(data: $data) {
      id
      type
      contentType
      key
      bucket
      name
      status
      createdAt
      foreignKeys
    }
  }
`;

export const DELETE_DOCUMENTS = gql`
  mutation DeleteDocuments($data: DeleteDocumentsInput!) {
    deleteDocuments(data: $data) {
      ids
    }
  }
`;

export const COMBINE_DOCUMENTS = gql`
  mutation CombineDocuments($data: CombineDocumentsInput!) {
    combineDocuments(data: $data) {
      id
      type
      contentType
      key
      bucket
      name
      status
      createdAt
      foreignKeys
    }
  }
`;

export const RETRY_UPLOAD_DOCUMENTS = gql`
  mutation RetryUploadDocuments($data: RetryUploadDocumentInput!) {
    retryUploadDocuments(data: $data) {
      message
    }
  }
`;

export const PROCESS_DOCUMENT = gql`
  mutation processDocument($data: ProcessDocumentInput!) {
    processDocument(data: $data) {
      documentId
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateDocumentByKey(
    $docKey: String!
    $payload: UpdateDocumentsPayloadInput!
  ) {
    updateDocumentByKey(docKey: $docKey, payload: $payload) {
      id
      type
      contentType
      key
      bucket
      name
      status
      createdAt
      foreignKeys
    }
  }
`;

export const CREATE_DOCUMENT_LINKS = gql`
  mutation CreateDocumentLinks($data: [CreateDocumentLinksInput!]!) {
  createDocumentLinks(data: $data) {
    createdAt
    updatedAt
    type
    link
    name
    uploadedBy
    foreignKeys
    id
  }
}
`;

export const UPDATE_DOCUMENT_LINKS = gql`
  mutation UpdateDocumentLink($payload: UpdateDocumentLinksPayloadInput!, $updateDocumentLinkId: String!) {
  updateDocumentLink(payload: $payload, id: $updateDocumentLinkId) {
    id
    createdAt
    updatedAt
    type
    link
    name
    uploadedBy
    foreignKeys
  }
}
`;

export const DELETE_DOCUMENT_LINKS = gql`
  mutation Mutation($data: DeleteDocumentLinksInput!) {
  deleteDocumentLinks(data: $data) {
    ids
  }
}
`;